<template>
  <div>
    <article id="project" v-if="project">
        <template v-if="layout.length">
          <scroll-view>
            <template slot-scope="visibility">
              <ProjectSection 
              :currentLang="currentLang"
              :section="section" 
              :index="index"
              v-for="(section, index) in layout" 
              :visible="visibility['section'+index]"
              :key="'section'+index"/>
            </template>
          </scroll-view>
          <LinkedProjects v-if="project[currentLang].linkedProjects && project[currentLang].linkedProjects.length" :projects="project[currentLang].linkedProjects" :currentLang="currentLang"/>
        </template>
      <transition name="slide-fade">
        <section v-if="!layout.length && isLandingMounted" class="alert">
          <p>Empty Project</p>
        </section>
      </transition>
    </article>
    <ContactFooter v-if="layout.length" :isLandingMounted="isLandingMounted" :displayLogo="true" :site="site"/>
  </div>
</template>

<script>
const ProjectSection = () => import( /* webpackChunkName: "ProjectSection" */ '@/snippets/ProjectSection.vue');
const ContactFooter = () => import( /* webpackChunkName: "ContactFooter" */ '@/snippets/ContactFooter.vue');
const LinkedProjects = () => import( /* webpackChunkName: "LinkedProjects" */ '@/snippets/LinkedProjects.vue');

import { $scrollview } from 'vue-scrollview'
import loaderHandler  from '@/mixins/loaderHandler.js'
import scrollBehavior  from '@/mixins/scrollBehavior.js'
import axios from 'axios';
import { mapState } from 'vuex'


const auth = {
  username: process.env.VUE_APP_USERNAME,
  password: process.env.VUE_APP_PASSWORD
}
const body = document.getElementsByTagName('body')[0];
export default {
  props: ['currentLang'],
  name: 'project',
  mixins: [loaderHandler, scrollBehavior],
  components: {
    ProjectSection,
    ContactFooter,
    LinkedProjects
  },
  data(){
    return {
      layout: [],
      scroll: $scrollview,
      isLandingMounted: false,
      sectionLoaded: false,
      data: {
        layout: [],
        page: null
      }
    }
  },
  watch:{
    visible(visible){
      if(visible){
        this.sectionLoaded = true;
      }
    },
    project(project){
      this.editData(project);
    },
    $route($route){
      this.$store.dispatch('loadProject', $route.params.id);
    },
    currentLang(){
      this.editData(this.project);
    }
  },
  methods:{
    displayClass(width){
      if(!width){
        return
      }
      let $class= "";
      switch(width){
        case '1/1':
          $class = 'w_100';
          break;
        case '1/2':
          $class = 'w_50';
          break;
        case '1/3':
          $class = 'w_33';
          break;
        case '2/3':
          $class = 'w_66';
          break;
        default:
          $class = 'w_100';
      }
      return $class;
    },
    editData(page){
      this.layout = [];
      if(!page || page[this.currentLang].mainContent == ""){
        return;
      }
      this.data.layout = page[this.currentLang].mainContent;
      this.data.id = page.id;
      this.parseLayout(this.data)
    },
    defineHeader(){
      this.$emit('mountedPage', {isBgLight: this.project[this.currentLang].headerColor == 'blanc' ? true : false});
      this.isLandingMounted = true;
    },
    parseLayout (data) {
      if(!data){
        return
      }
      let self = this;
      axios.post('/api/parse-layout', data, { auth }
      ).then(function(response) {
        if(response.data.redirection){
          self.$router.push('home');
        }
        self.layout = Object.values(response.data.layout);
        self.defineHeader();
      }).catch(error => {
        self.error = error
      });
    },
  },
  computed: mapState(['project', 'site']),
  mounted(){
    let self = this;
    setTimeout(function(){
      self.isLandingMounted = true
    }, 500);
    this.editData(this.project);
    body.classList.add('project-page');
  },
  beforeDestroy(){
    this.emitToApp(true);
    body.classList.remove('project-page');
  }
}
</script>

<style lang="scss">
  #project{
    position:relative;
    background-color: #fff;
    min-height:100vh;
    @media screen and (max-width:768px){
      margin-top: 5.3rem;
    }
    > span{
      display:block;
      min-height:100vh;
    }
    .alert{
      position: absolute;
      background-color: var(--darkGrey);
      color: #fff;
      top:-100px;
      left:0;
      width: 100%;
      height: 100vh;
      font-size: 3em;
      text-align: center;
      p{
        position:relative;
        top: 50%;
        left:50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        display:block;
      }
    }
  }

  .bloc--regular{
    padding: 2em;
    @media screen and (min-width:1024px){
      padding: 0;
      > div{
        padding: 5.33333em;
        &.w_66:first-child,
        &.w_50:first-child{
          padding-right:3.33333em
        }
        &.w_33:last-child,
        &.w_50:last-child{
          padding-left:3.33333em
        }
        &.w_33:nth-child(2){
          padding-right:3.33333em;
          padding-left:3.33333em;
        }
      }
    }
  }

  @media screen and (max-width:1024px){
      .w_33 + .w_66,
      .w_66 + .w_33,
      .w_33 + .w_33,
      .w_50 + .w_50{
        margin-top:2em;
       }
    }


</style>
